module.exports = __webpack_public_path__ + "static/media/icon-text.267293ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-text.svg
// module id = 931
// module chunks = 0